import {List, Map} from 'immutable';
import {EMPTY_STATE} from './reducer';

export const openPartyDetailsOverlay = (state) => {
  return state.set('partyDetailsOverlayOpen', true);
};

export const closePartyDetailsOverlay = (state, reset) => {
  if (reset) {
    return EMPTY_STATE;
  }

  return state.set('partyDetailsOverlayOpen', false);
};

export const setTravellerValue = (state, type, value, roomIndex) => {

  const room = state.getIn(['rooms', roomIndex]);
  const updatedTravelerCount = state.setIn(['rooms', roomIndex, type], value);


  if (type === 'children') {

    const currentChildList = room.get('childAges');
    let newChildList = new List(Array(value));

    currentChildList.map((age, i) => {
      //move the values from the old child list into the new one, to preserve already entered
      //details, but remove ones that are no longer needed
      if (i >= newChildList.count()) {
        return null;
      }
      if (age) {
        newChildList = newChildList.set(i, age);
      }
      return null;
    });
    return updatedTravelerCount.setIn(['rooms', roomIndex, 'childAges'], newChildList);
  }
  return updatedTravelerCount;
};

export const setNumberOfRooms = (state, value) => {
  return state.set('numberOfRooms', value);
};

export const setChildAge = (state, roomIndex, childIndex, age) => {
  return state.setIn(['rooms', roomIndex, 'childAges', childIndex], new Map({age, dirty: true}));
};

export const setErrorVisibility = (state, errorVisibility) => {
  return state.set('errorVisibility', errorVisibility);
};

export const getFormValidity = (state) => {
  const numberOfRooms = state.get('numberOfRooms', 1);
  const roomData = state.get('rooms');
  let valid = true;

  const validityStates = {
    error: true,
    button: true
  };

  for (let i = 0; i < numberOfRooms; i++) {
    const room = roomData.get(i);
    valid = valid && (room.get('childAges').count() === room.get('children'));

    validityStates.button = validityStates.button && !room.get('childAges').some(age => {
      return age === undefined || age === null || age === '' || age.get('age') === '';
    });
  }

  return validityStates;
};
